import axios from 'axios'
import mainMenuModule from './main-menu'

export default {
  namespaced: true,
  modules: {
    mainMenuModule: mainMenuModule
  },
  state: {
    regions: [],
    countries: [],
    sites: [],
    comparisonSites: []
  },
  mutations: {
    CLEAR_MAP_DATA (state) {
      state.regions = []
      state.countries = []
      state.sites = []
    },
    UPDATE_MAP_DATA (state, mapData) {
      state.regions = []
      state.countries = []
      state.sites = []
      state.regions = mapData.regions
      state.countries = mapData.countries
      state.sites = mapData.sites
    },
    ADD_SITE_COMPARISON (state, site) {
      state.comparisonSites.push(site)
    },
    REMOVE_SITE_COMPARISON (state, index) {
      state.comparisonSites.splice(index, 1)
    },
    CLEAR_SITE_COMPARISON (state) {
      state.comparisonSites = []
    }
  },
  actions: {
    clearMapData (context) {
      context.commit('CLEAR_MAP_DATA')
    },
    async loadMapData (context, url) {
      // console.log(this.state.mainMenuModule.rootAPI + url)
      try {
        // const response = await axios.get(this.state.mainMenuModule.rootAPI + url)
        const response = await axios.get(this.getters.baseURL + url)
        if (!response.data.hasOwnProperty('error')) {
          context.commit('UPDATE_MAP_DATA', response.data)
        }
      } catch (e) {
        console.log(e)
      }
    },
    toggleSiteComparison (context, site) {
      // console.log(site)
      const index = context.state.comparisonSites.map(it => it.code).indexOf(site.code)
      if (index > -1) {
        context.commit('REMOVE_SITE_COMPARISON', index)
        // context.state.comparisonSites.splice(index, 1)
      } else {
        context.commit('ADD_SITE_COMPARISON', site)
        // context.state.comparisonSites.push(site)
      }
    },
    clearSiteComparison (context) {
      context.commit('CLEAR_SITE_COMPARISON')
    }
  },
  getters: {
    comparisonSites: state => state.comparisonSites
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/map.js